export default __webpack_public_path__ + "static/content-1-bd9cb16eb03925b51ac8f4b15526ae6c.jpg";